export const aboutData = {
  brandName: '一起草',
  tagline: '让创作更简单，让表达更有力',
  introduction: '一起草成立于2024年，是一家专注于AI内容创作技术研发的科技公司。我们致力于通过人工智能技术，降低内容创作的门槛，让每个人都能轻松产出高质量的文字内容。无论是自媒体创作者、企业营销团队，还是学生和研究人员，一起草都能为你提供高效、智能的创作解决方案。',
  vision: '成为全球最受欢迎的AI内容创作平台，用技术赋能每一位创作者',
  mission: '让创作触手可及，让好内容不再难产',
  values: [
    { title: '用户至上', description: '始终以用户需求为导向，打造真正好用的产品' },
    { title: '技术创新', description: '持续投入AI技术研发，保持行业领先水平' },
    { title: '内容质量', description: '坚持高质量内容标准，为用户提供可靠创作支持' },
    { title: '开放共赢', description: '构建开放的创作生态，与创作者共同成长' },
  ],
  milestones: [
    { year: '2024年3月', title: '项目启动', description: '一起草项目正式立项，核心团队组建完成' },
    { year: '2024年9月', title: '内测版本上线', description: '邀请首批100位种子用户参与内测，收集反馈' },
    { year: '2025年1月', title: '正式版发布', description: '一起草1.0正式上线，开放注册' },
    { year: '2025年6月', title: '用户突破10万', description: '平台注册用户突破10万，日活跃用户超1万' },
    { year: '2025年12月', title: '团队协作功能上线', description: '推出团队版，支持多人实时协作编辑' },
    { year: '2026年3月', title: 'AI引擎全面升级', description: '升级至第三代AI模型，生成质量大幅提升' },
    { year: '2026年8月', title: '移动端App内测', description: 'iOS和Android客户端进入内测阶段' },
  ],
  stats: [
    { value: '500,000+', label: '注册用户' },
    { value: '200万+', label: '生成文章数' },
    { value: '98.5%', label: '用户满意度' },
    { value: '30+', label: '覆盖行业领域' },
  ],
  contact: {
    email: 'support@yiqicao.com',
    phone: '400-888-9999',
    address: '北京市海淀区中关村科技园区创新路88号',
    workingHours: '周一至周五 9:00-18:00',
  },
};

export const faqList = [
  {
    question: '一起草是什么？',
    answer: '一起草是一个基于人工智能技术的内容创作平台，提供AI智能写作、文章润色、大纲生成、多语言翻译等核心功能，帮助用户高效产出高质量的文字内容。',
  },
  {
    question: '一起草官网入口在哪里？',
    answer: '一起草的官方网站入口即为您当前访问的页面。您可以将本页面加入书签以便快速访问。官方网站提供平台介绍、功能介绍、使用教程和最新动态等完整信息。',
  },
  {
    question: '如何注册一起草账号？',
    answer: '点击页面右上角的「注册」按钮，填写邮箱地址和基本信息，完成邮箱验证后即可成功注册。注册过程通常只需要1-2分钟。',
  },
  {
    question: '一起草是免费的吗？',
    answer: '一起草提供免费版和专业版两种方案。免费版每天可生成3篇文章，专业版无限制使用并享有更多高级功能。我们建议新用户从免费版开始体验。',
  },
  {
    question: '一起草支持哪些语言？',
    answer: '一起草核心支持中文和英文创作，同时提供日语、韩语、法语、德语、西班牙语等多语言翻译功能，满足国际化创作需求。',
  },
  {
    question: '生成的内容可以商用吗？',
    answer: '是的，通过一起草生成的内容版权归用户所有，可以自由用于商业用途。我们建议在发布前进行适当的人工审核和调整，以确保内容完全符合您的需求。',
  },
  {
    question: '如何联系一起草客服？',
    answer: '您可以通过以下方式联系我们的客服团队：发送邮件至 support@yiqicao.com，或拨打客服热线 400-888-9999（周一至周五 9:00-18:00）。我们的客服团队将在1个工作日内回复您的咨询。',
  },
];